import { Caption, Header, OuterContainer } from "./styles";
import styled from "styled-components";

const LicenseContainer = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  text-align: left;
`;

const Section = styled.div`
  margin-bottom: 30px;
`;

const Quote = styled.blockquote`
  background-color: #f5f5f5;
  border-left: 4px solid #ccc;
  margin: 15px 0;
  padding: 10px 15px;
  font-style: italic;
`;

const List = styled.ul`
  margin: 15px 0;
  padding-left: 20px;
`;

const ListItem = styled.li`
  margin-bottom: 8px;
`;

export default function License() {
  return (
    <OuterContainer>
      <LicenseContainer>
        <Header>THIRD-PARTY LICENSE FOR SENTIENTS</Header>

        <p>
          Tedbot Games grants anyone the right to create, publish, and sell
          third-party content compatible with <em>Sentients</em>, under the
          following terms:
        </p>

        <Section>
          <Header>1. ATTRIBUTION</Header>
          <p>You must include the following text in your product or listing:</p>
          <Quote>
            "Compatible with <em>Sentients</em>. <em>Sentients</em> is a
            roleplaying game created by Ted Hayes of Tedbot Games. This product
            is not affiliated with or endorsed by Tedbot Games."
          </Quote>
        </Section>

        <Section>
          <Header>2. OWNERSHIP</Header>
          <p>
            You retain ownership of your content. Tedbot Games retains ownership
            of <em>Sentients</em>, its setting, mechanics, and trademarks.
          </p>
        </Section>

        <Section>
          <Header>3. WHAT'S ALLOWED</Header>
          <p>
            <List>
              <ListItem>
                You may reference game mechanics, rules, themes, and terminology
                from <em>Sentients</em>.
              </ListItem>
              <ListItem>
                You may publish content in any format (PDF, print, web, etc.),
                for free or for sale.
              </ListItem>
            </List>
          </p>
        </Section>

        <Section>
          <Header>4. WHAT'S NOT ALLOWED</Header>
          <p>
            <List>
              <ListItem>
                You may not use official <em>Sentients</em> logos, artwork,
                maps, or verbatim text from the Core Rulebook (other than brief
                excerpts for reference).
              </ListItem>
              <ListItem>
                You may not imply that your content is officially endorsed by
                Tedbot Games.
              </ListItem>
              <ListItem>
                You may not crowdfund or publish new core rulebooks or major
                expansions that might be confused with official products.
              </ListItem>
            </List>
          </p>
        </Section>

        <Section>
          <Header>5. LOGO USAGE</Header>
          <p>
            You may use{" "}
            <a href="/logos">
              official <em>Sentients</em> compatibility logos
            </a>{" "}
            provided by Tedbot Games. These logos may be used to indicate
            compatibility but may not be modified or used in a way that implies
            official endorsement or authorship by Tedbot Games.
          </p>
        </Section>

        <Section>
          <Header>6. REVOCATION</Header>
          <p>
            Tedbot Games reserves the right to update or revoke this license,
            but will do so with fair notice and only for legal or ethical
            reasons.
          </p>
        </Section>

        <Caption>GAME DESIGN BY TED HAYES</Caption>
      </LicenseContainer>
    </OuterContainer>
  );
}
